import { createApiOriginMetaTag } from '@hungryroot/dev-mode';
import { isProductionEnvironment } from '@hungryroot/environment';

if (!isProductionEnvironment()) {
  createApiOriginMetaTag();
}

// Sentry is initialised by `frontend/react/init-observability.ts`, which
// `webpack.config.js` prepends to every React entry — this one included.

import './src/utils/configure_jquery';

import './src/base_v3';
import './src/food_profile';
